import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { Grid, Row, Column, Button, cls } from 'packages/components';
import { subMenu, VCARD_MATCH_MENU } from '../utils/constants';
import { redirect } from '../index';
import './_styles.scss';
import Device from 'src/devices/device';
import { autobind } from 'packages/core/lib';
import Utils from 'src/utils/Utils';
import { navigationDownSoccer } from 'src/components/RibbonNew/functions.mundial';
interface IOptionsItems {
    name: string;
    href: string;
}
interface IMenuProps {
    options: IOptionsItems[];
    history: RouteComponentProps;
    idMatch: null | string;
}

export class Menu extends Component<IMenuProps> {
    keys: any;
    constructor(props: IMenuProps) {
        super(props);
        this.keys = (Device.getDevice() && Device.getDevice().getKeys()) || null;
    }

    @autobind
    private async handleKeyPress(e: any): Promise<void> {
        const ids = subMenu.map(({ name }) => name);
        const currentKey = this.keys ? this.keys.getPressKey(e.keyCode) : null;
        const { idMatch, history } = this.props;

        const reviewIncludesMenuIds = ids.includes(e.target.id);
        const reviewIncludesStringIdsHome = e.target.id.includes('-home');
        const reviewInitComment = e.target.id === 'comment-0';
        const UP = currentKey === 'UP';
        const DOWN = currentKey === 'DOWN';

        this.setState({ currentKey });
        if (UP && reviewIncludesMenuIds) {
            await redirect(history, '/', 0, idMatch);
        } else if (UP && (reviewInitComment || reviewIncludesStringIdsHome)) {
            e.preventDefault();
            e.stopPropagation();
            Utils.setInitialFocusChangeTime('.button-container-pos-0', 0);
        } else if (DOWN && reviewIncludesMenuIds) {
            const elementScroll = document.getElementsByClassName('ribbon-items');
            elementScroll.length > 0 && navigationDownSoccer(e, 0);
        }
    }

    @autobind
    private addEventListener() {
        document.removeEventListener('keydown', this.handleKeyPress, true);
        document.addEventListener('keydown', this.handleKeyPress, true);
    }

    @autobind
    private removeEventListener() {
        document.removeEventListener('keydown', this.handleKeyPress, true);
    }

    componentDidMount() {
        this.addEventListener();
    }

    componentWillUnmount() {
        this.removeEventListener();
    }
    render() {
        const {
            location: { pathname },
        } = this.props.history;
        const { options, history } = this.props;
        return (
            <Grid>
                <Row>
                    <Column lg={12}>
                        <div className={`${VCARD_MATCH_MENU}-container`}>
                            {options.map(({ name, href }, index) => {
                                const selected = pathname.includes(href) ? 'selected' : '';
                                return (
                                    <Button
                                        key={href}
                                        id={name}
                                        type="button"
                                        className={cls(
                                            `${index === options.length - 1 ? 'last' : ''}`,
                                            'focusable',
                                            'button-container',
                                            `button-container-pos-${index}`,
                                            `${selected}`
                                        )}
                                        variant="default"
                                        onClick={async () => await redirect(history, href, 500)}
                                    >
                                        {`${name}`}
                                    </Button>
                                );
                            })}
                        </div>
                    </Column>
                </Row>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/mundial/Vcards/VcardMatch/Menu/index.tsx